var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 33.5",
    style: {
      enableBackground: "new 0 0 26 33.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2FDA7B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_9042662_notes_icon",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M22,21.5H10c-0.6,0-1-0.4-1-1s0.4-1,1-1h12c0.6,0,1,0.4,1,1S22.6,21.5,22,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,15.5h-3c-0.6,0-1-0.4-1-1s0.4-1,1-1h3c0.6,0,1,0.4,1,1S13.6,15.5,13,15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,27.5h-6c-0.6,0-1-0.4-1-1s0.4-1,1-1h6c0.6,0,1,0.4,1,1S16.6,27.5,16,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,33.5H7c-2.2,0-4-1.8-4-4V7c0-2.2,1.8-4,4-4h5V1c0-0.6,0.4-1,1-1s1,0.4,1,1v6c0,0.6-0.4,1-1,1s-1-0.4-1-1V5 H7C5.9,5,5,5.9,5,7v22.5c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V7c0-1.1-0.9-2-2-2h-5.2c-0.6,0-1-0.4-1-1s0.4-1,1-1H25 c2.2,0,4,1.8,4,4v22.5C29,31.7,27.2,33.5,25,33.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscription);
export default __webpack_public_path__ + "static/media/subscription.8af2b57d25e80bb23f7dc2f507600c09.svg";
export { ForwardRef as ReactComponent };